export enum ROUTE_NAMES {
  INTRO = 'Intro',
  HOME = 'Home',
  LOGIN = 'Login',
  PROFILE = 'Profile',
  PRODUCT = 'Product',
  ACCESS = 'Access'
}
